import React from "react";
import { Select, DatePicker, Input } from "antd";
import { inject, observer } from "mobx-react";
import moment from "moment";
import "moment/locale/zh-cn";
import "moment/locale/en-au";

import agent from "../../../../agent";
import { $util, $const } from "../../../../helper";

import "./style/inputsLego.scss";

import "./style/personalInfo.scss";
const { MonthPicker } = DatePicker;
const { Option } = Select;

export const EDUCATION = [
  {
    value: "初中及以下",
    ch: "初中及以下",
    en: "Junior High School And Below"
  },
  {
    value: "高中",
    ch: "高中",
    en: "Senior High School"
  },
  {
    value: "中技（中专/技校/职高）",
    ch: "中技（中专/技校/职高）",
    en: "Technical Secondary School"
  },
  {
    value: "高职（专科）",
    ch: "高职（专科）",
    en: "Technical Junior College"
  },
  {
    value: "本科（普通教育）",
    ch: "本科（普通教育）",
    en: "Undergraduate"
  },
  {
    value: "本科（职业教育）",
    ch: "本科（职业教育）",
    en: "Undergraduate"
  },
  {
    value: "学术型硕士",
    ch: "学术型硕士",
    en: "Postgraduate"
  },
  {
    value: "专业学位硕士",
    ch: "专业学位硕士",
    en: "Postgraduate"
  },
  {
    value: "学术型博士",
    ch: "学术型博士",
    en: "Doctoral Degree Candidates"
  },
  {
    value: "专业学位博士",
    ch: "专业学位博士",
    en: "Doctoral Degree Candidates"
  }
];

export const EduSelect = props => {
  const { lang, ...restProps } = props;
  return (
    <Select {...restProps}>
      {EDUCATION.map((item, idx) => {
        const { value, ch, en } = item;
        return (
          <Option index={idx} value={value}>
            {lang === "zh" ? ch : en}
          </Option>
        );
      })}
    </Select>
  );
};
@inject("languageStore")
@observer
export class SchoolSelect extends React.Component {
  state = {
    schoolOptions: []
  };

  fetchOptions = name =>
    name
      ? agent.SassPlatform.searchSchools({ name, mode: "2" }).then(res => {
          if (res && res.success && Array.isArray(res.data) && res.data.length > 0) {
            this.setState({
              schoolOptions: res.data
            });
          } else {
            this.setState({
              schoolOptions: []
            });
          }
        })
      : this.setState({
          schoolOptions: []
        });

  handleSearch = $util.debounce(value => {
    this.fetchOptions(value);
    const { onChange } = this.props;
    onChange && onChange(value);
  }, 300);

  handleSelect = value => {
    const { onChange } = this.props;
    onChange && onChange(value);
  };

  renderOptions = () => {
    const lang = this.props.languageStore.lang;
    return this.state.schoolOptions.map(item => {
      const text = lang === "zh" ? item.name || item.enName : item.enName || item.name;
      return (
        <Option value={text} key={item.id}>
          {text}
        </Option>
      );
    });
  };

  render() {
    const { onChange, ...restProps } = this.props;

    return (
      <Select
        allowClear
        showSearch
        defaultActiveFirstOption={false}
        showArrow={false}
        filterOption={false}
        onSearch={this.handleSearch}
        onSelect={this.handleSelect}
        notFoundContent={null}
        {...restProps}
      >
        {this.renderOptions()}
      </Select>
    );
  }
}

export class MajorsSelect extends React.Component {
  state = {
    data: [],
    value: undefined
  };

  handleSearch = $util.debounce(value => {
    if (value) {
      agent.Common.getMajors(value).then(res => {
        if (res.status === 200 && res.body && Array.isArray(res.body.majors)) {
          this.setState({
            data: res.body.majors
          });
        }
      });
    } else {
      this.setState({ data: [] });
    }
  }, 300);

  handleChange = value => {
    this.setState({ value });
  };

  render() {
    const { schoolList, ...restProps } = this.props;

    const options = this.state.data.map((item, index) => (
      <Option key={index} value={item}>
        {item}
      </Option>
    ));

    return (
      <Select
        allowClear
        showSearch
        defaultActiveFirstOption={false}
        showArrow={false}
        filterOption={false}
        onSearch={this.handleSearch}
        onChange={this.handleChange}
        notFoundContent={null}
        {...restProps}
      >
        {options}
      </Select>
    );
  }
}

@inject("languageStore")
@observer
export class TimePicker extends React.Component {
  handleOnChange = e => {
    const { onChange } = this.props;
    onChange && onChange(e ? e.format("YYYY-MM-DD") : e);
  };

  disabledDate = current => {
    const { disabledStart, disabledEnd } = this.props;
    if (!disabledStart && !disabledEnd) return false;
    if (disabledStart) {
      return current && current < moment(disabledStart);
    }
    if (disabledEnd) {
      return current && current > moment(disabledEnd);
    }
  };

  render() {
    const { lang, value, disabledDateTime, ...restProps } = this.props;
    if (lang === "en") {
      moment.locale("en");
    } else {
      moment.locale("zh-cn");
    }

    return (
      <MonthPicker
        {...restProps}
        disabledDate={this.disabledDate}
        value={value ? moment(value) : value}
        onChange={this.handleOnChange}
      />
    );
  }
}

// 支持作为表单子元素的电话输入组件
export const PhoneNumInput = props => {
  const { value, onChange } = props;
  const [preValue, phoneNum] = (value || "").split(" ");

  /**
   * 号码前缀
   */
  const handlePreNumSelect = value => {
    phoneNum && onChange && onChange(`${value} ${phoneNum}`);
  };

  /**
   * 号码
   */
  const handleNumChange = e => {
    onChange && onChange(`${preValue} ${e.target.value}`);
  };

  const selectBefore = (
    <Select
      onSelect={handlePreNumSelect}
      value={preValue}
      className="inputsLego__phoneNumInput--pre"
    >
      {$const.PHONE_PREFIX.map((item, idx) => {
        const itemValue = `+${item}`;
        return (
          <Select.Option key={`${item}-${idx}`} value={itemValue}>
            {itemValue}
          </Select.Option>
        );
      })}
    </Select>
  );

  return (
    <Input
      className="inputsLego__phoneNumInput"
      addonBefore={selectBefore}
      onChange={handleNumChange}
      value={phoneNum}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/formList/gameForm/personalInfoInput/inputsLego.js